<template>
    <v-btn
        id="feedback-activator"
        variant="flat"
        rounded="circle"
        height="70"
        width="70"
        color="#001FA3">
        <svg width="31" height="25" viewBox="0 0 31 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.83317 0.833313H27.1665C28.7707 0.833313 30.0832 2.14581 30.0832 3.74998V21.25C30.0832 22.8541 28.7707 24.1666 27.1665 24.1666H3.83317C2.229 24.1666 0.916504 22.8541 0.916504 21.25L0.931087 3.74998C0.931087 2.14581 2.229 0.833313 3.83317 0.833313ZM15.4998 13.9583L27.1665 6.66665V3.74998L15.4998 11.0416L3.83317 3.74998V6.66665L15.4998 13.9583Z" 
            fill="white"/>
        </svg>
    </v-btn>
</template>
<script>

export default{
    name: 'BtnFeedback'
}

</script>